import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useExtensionManager } from '@/hooks/useExtensionManager';
import NewNoteModal from '@/components/CustomModal/NewNoteModal';

/**
 * Watches for #pop in the URL hash and triggers the Chrome extension check.
 * If the extension is installed, it opens it. If not, shows the install modal.
 * Strips the hash after processing to keep URLs clean.
 *
 * Usage: Add any NoteGo URL with #pop appended, e.g. notego.io/home#pop
 */
const ExtensionHashTrigger = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isModalOpen, checkExtensionInstalled, onModalConfirm, setIsModalOpen } = useExtensionManager();
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    if (location.hash !== '#pop') return;

    processedRef.current = true;
    // Strip the hash so it doesn't persist in the URL bar
    navigate(location.pathname + location.search, { replace: true });
    // Trigger the extension check — opens it or shows install modal
    checkExtensionInstalled();
  }, [location.hash, location.pathname, location.search, navigate, checkExtensionInstalled]);

  return <NewNoteModal open={isModalOpen} handleClose={() => setIsModalOpen(false)} onConfirm={onModalConfirm} />;
};

export default ExtensionHashTrigger;
